
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class UtilitiesWriterService {

   public static getPanFromImg(
           axiosInstance: AxiosInstance, input: ServerData.UtilitiesWebWriter.GetPanFromImg$Input,
           f: (output: ServerData.UtilitiesWebWriter.GetPanFromImg$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'insightapi/utilities/get-pan-from-img',
            input.toFormData()
        ).then((response) => ServerData.UtilitiesWebWriter.GetPanFromImg$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

